import React from 'react';
import { Helmet } from 'react-helmet';
import { Routes, Route, Link } from 'react-router-dom';
import Header from './components/Header';
import Home from './pages/home/Home';
import About from './pages/about/About';
import Contact from './pages/contact/Contact';
import Footer from './components/Footer';
import "bootstrap-icons/font/bootstrap-icons.css";
import WeekendTours from "./pages/tours/WeekendTours";
import TourDetails from "./pages/tours/TourDetails";
import HomeFaqs from "./components/faqs/HomeFaqs";
import ClientTestimonials from "./components/testimonials/ClientTestimonials";
import Khajuraho from "./pages/khajuraho/Khajuraho";
import KhajurahoDetail from "./pages/khajuraho/KhajurahoDetail";
import ScrollRevealGallery from './pages/ScrollRevealGallery/ScrollRevealGallery';
import FloatingContactButtons from './components/common/FloatingContactButtons';
import Preloader from './components/common/Preloader';
import PolicySection from './pages/yatra/PolicySection';
import PageTransition from './components/PageTransition';
import ScrollToTop from './components/ScrollToTop';
import BusRent from './pages/busrent/BusRent';
import Services from './pages/services/Services';
import PrivacyPolicy from './pages/policies/PrivacyPolicy';
import TermsConditions from './pages/policies/TermsConditions';
import CancellationPolicy from './pages/policies/CancellationPolicy';
import Disclaimer from './pages/policies/Disclaimer';
import TransportCharges from './pages/transport/TransportCharges';
import Hotels from './pages/hotels/Hotels';
import Taxi from './pages/taxi/Taxi';
import NewsMedia from './pages/newsMedia/NewsMedia';
import BlogDetails from './pages/newsMedia/BlogDetails';

const NotFound = () => (
  <>
    <Helmet>
      <title>Page Not Found | Khajuraho Routes</title>
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <section className="min-h-[60vh] flex flex-col items-center justify-center text-center px-6 py-20">
      <h1 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">Page Not Found</h1>
      <p className="text-gray-600 mb-8 max-w-xl">The page you are looking for has moved or no longer exists. Explore our tours, taxi services or contact us.</p>
      <div className="flex flex-wrap gap-4 justify-center">
        <Link to="/tours" className="px-6 py-3 rounded-full bg-orange-600 text-white font-bold">View Tours</Link>
        <Link to="/taxi" className="px-6 py-3 rounded-full border border-gray-300 font-bold">Book Taxi</Link>
        <Link to="/contact" className="px-6 py-3 rounded-full border border-gray-300 font-bold">Contact Us</Link>
      </div>
    </section>
  </>
);

const App = () => {
  return (
    <>
      <Preloader />
      <Header />
       <ScrollToTop/>
      <PageTransition>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/tours" element={<WeekendTours />} />
          <Route path="/tours/:id" element={<TourDetails />} />
          <Route path="/faqs" element={<><Helmet><title>FAQs | Khajuraho Routes</title><meta name="description" content="Frequently Asked Questions about Khajuraho tourism and our services." /><link rel="canonical" href="https://khajurahoroutes.com/faqs" /></Helmet><HomeFaqs /></>} />
          <Route path="/testimonials" element={<><Helmet><title>Testimonials | Khajuraho Routes</title><meta name="description" content="Read reviews and testimonials from our happy travelers." /><link rel="canonical" href="https://khajurahoroutes.com/testimonials" /></Helmet><ClientTestimonials /></>} />
          <Route path="/khajuraho" element={<Khajuraho />} />
          <Route path="/khajuraho/:id" element={<KhajurahoDetail />} />
          <Route path="/scroll-gallery" element={<ScrollRevealGallery />} />

          <Route path="/hotels" element={<Hotels />} />
          <Route path="/taxi" element={<Taxi />} />
          <Route path="/busrent" element={<BusRent />} />
          <Route path="/services" element={<Services />} />
          <Route path="/privacy-policy" element={<><Helmet><title>Privacy Policy | Khajuraho Routes</title><meta name="description" content="Read the privacy policy of Khajuraho Routes - how we collect, use and protect your information for tour bookings in Khajuraho." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/privacy-policy" /></Helmet><PrivacyPolicy /></>} />
          <Route path="/terms-conditions" element={<><Helmet><title>Terms & Conditions | Khajuraho Routes</title><meta name="description" content="Read the terms and conditions for booking Khajuraho tours, taxi and hotel services with Khajuraho Routes." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/terms-conditions" /></Helmet><TermsConditions /></>} />
          <Route path="/cancellation-policy" element={<><Helmet><title>Cancellation Policy | Khajuraho Routes</title><meta name="description" content="Read the cancellation and refund policy for Khajuraho tour packages, taxi and hotel bookings." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/cancellation-policy" /></Helmet><CancellationPolicy /></>} />
          <Route path="/disclaimer" element={<><Helmet><title>Disclaimer | Khajuraho Routes</title><meta name="description" content="Read the disclaimer for travel information, itineraries and services published by Khajuraho Routes." /><meta name="robots" content="noindex, follow" /><link rel="canonical" href="https://khajurahoroutes.com/disclaimer" /></Helmet><Disclaimer /></>} />
          <Route path="/transport-charges" element={<TransportCharges />} />
          <Route path="/news-media" element={<NewsMedia />} />
          <Route path="/news-media/:id" element={<BlogDetails />} />
          <Route path="*" element={<NotFound />} />

        </Routes>
       
      </PageTransition>
 <FloatingContactButtons />
      <Footer />
    </>
  );
};

export default App;
